var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGbpFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 45,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h60v45H0V0Z",
    fill: "#012169"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.031 0 22.875 16.969L52.688 0H60v5.813l-22.5 16.78L60 39.282V45h-7.5L30 28.219 7.594 45H0v-5.625l22.406-16.688L0 6V0h7.031Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.75 26.344 60 41.25V45L34.594 26.344h5.156ZM22.5 28.219l.563 3.281-18 13.5H0l22.5-16.781ZM60 0v.281L36.656 17.906l.188-4.125L55.312 0H60ZM0 0l22.406 16.5h-5.625L0 3.937V0Z",
    fill: "#C8102E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.594 0v45h15V0h-15ZM0 15v15h60V15H0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 18.094v9h60v-9H0ZM25.594 0v45h9V0h-9Z",
    fill: "#C8102E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h60v45H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGbpFlag);
export default __webpack_public_path__ + "static/media/gbp-flag.e2d8285a638a0735596acac3be30d169.svg";
export { ForwardRef as ReactComponent };